<template>
  <v-sheet class="mx-auto" max-width="2000">
    <v-card class="mx-auto" elevation="0"
            title="Healthcare resource utilization"
            subtitle="Follow-up year 1 is within 0-12 months from index date, year 2 is within 13-24 months, etc. Total number of patients at risk is also shown.">
      <v-row align="center" no-gutters>
        <v-col cols="12" lg="6" xl="6" xxl="6">
          <v-card class="mx-auto" min-height="800" elevation="0" title=""
                  ref="healthcare-resource-utilization-in-patient-care-visits-by-icd-chart">
            <v-row no-gutters>
              <v-col>
                <GChart type="ColumnChart"
                        @ready="healthcareResourceUtilizationInPatientCareVisitsByIcdChartReady"
                        :data="healthcareResourceUtilizationInPatientCareVisitsByIcdChartData"
                        :options="healthcareResourceUtilizationInPatientCareVisitsByIcdChartOptions"
                        :key="'healthcareResourceUtilizationInPatientCareVisitsByIcdChart' + healthcareResourceUtilizationInPatientCareVisitsByIcdChartKeyIndex"
                        v-if="healthcareResourceUtilizationInPatientCareVisitsByIcdChartData.length !== 0"/>
                <v-progress-circular color="primary" indeterminate v-else></v-progress-circular>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col class="ms-10">
                <v-checkbox v-model="healthcareResourceUtilizationInPatientCareVisitsByIcdChartSelectedRelative"
                            label="Visits per patient in care"
                            hide-details></v-checkbox>
              </v-col>
              <v-col>
                <v-checkbox v-model="healthcareResourceUtilizationInPatientCareVisitsByIcdChartSelectedPatientsAtRisk"
                            label="Show patients at risk"
                            hide-details></v-checkbox>
              </v-col>
              <v-col>
                <v-checkbox v-model="healthcareResourceUtilizationInPatientCareVisitsByIcdChartSelectedPatientsInCare"
                            label="Show patients in care"
                            hide-details></v-checkbox>
              </v-col>
              <v-col class="me-10 text-right">
                <vue-to-print :content="() => this.$refs['healthcare-resource-utilization-in-patient-care-visits-by-icd-chart'].$el"
                              :document-title="icd + '-' + 'healthcare-resource-utilization-in-patient-care-visits-by-icd-chart'"
                              remove-after-print>
                  <template v-slot:trigger>
                    <v-btn variant="plain" icon="mdi-printer" class="end"></v-btn>
                  </template>
                </vue-to-print>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" lg="6" xl="6" xxl="6">
          <v-card class="mx-auto" min-height="800" elevation="0" title=""
                  ref="healthcare-resource-utilization-in-patient-care-days-by-icd-chart">
            <v-row no-gutters>
              <v-col>
                <GChart type="ColumnChart"
                        @ready="healthcareResourceUtilizationInPatientCareDaysByIcdChartReady"
                        :data="healthcareResourceUtilizationInPatientCareDaysByIcdChartData"
                        :options="healthcareResourceUtilizationInPatientCareDaysByIcdChartOptions"
                        :key="'healthcareResourceUtilizationInPatientCareDayssByIcdChart' + healthcareResourceUtilizationInPatientCareDaysByIcdChartKeyIndex"
                        v-if="healthcareResourceUtilizationInPatientCareDaysByIcdChartData.length !== 0"/>
                <v-progress-circular color="primary" indeterminate v-else></v-progress-circular>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col class="ms-10">
                <v-checkbox v-model="healthcareResourceUtilizationInPatientCareDaysByIcdChartSelectedRelative"
                            label="Days per patient in care"
                            hide-details></v-checkbox>
              </v-col>
              <v-col>
                <v-checkbox v-model="healthcareResourceUtilizationInPatientCareDaysByIcdChartSelectedPatientsAtRisk"
                            label="Show patients at risk"
                            hide-details></v-checkbox>
              </v-col>
              <v-col>
                <v-checkbox v-model="healthcareResourceUtilizationInPatientCareDaysByIcdChartSelectedPatientsInCare"
                            label="Show patients in care"
                            hide-details></v-checkbox>
              </v-col>
              <v-col class="me-10 text-right">
                <vue-to-print :content="() => this.$refs['healthcare-resource-utilization-in-patient-care-days-by-icd-chart'].$el"
                              :document-title="icd + '-' + 'healthcare-resource-utilization-in-patient-care-days-by-icd-chart'"
                              remove-after-print>
                  <template v-slot:trigger>
                    <v-btn variant="plain" icon="mdi-printer" class="end"></v-btn>
                  </template>
                </vue-to-print>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" lg="6" xl="6" xxl="6">
          <v-card class="mx-auto" min-height="800" elevation="0" title=""
                  ref="healthcare-resource-utilization-out-patient-care-visits-by-icd-chart">
            <v-row no-gutters>
              <v-col>
                <GChart type="ColumnChart"
                        @ready="healthcareResourceUtilizationOutPatientCareVisitsByIcdChartReady"
                        :data="healthcareResourceUtilizationOutPatientCareVisitsByIcdChartData"
                        :options="healthcareResourceUtilizationOutPatientCareVisitsByIcdChartOptions"
                        :key="'healthcareResourceUtilizationOutPatientCareVisitsByIcdChart' + healthcareResourceUtilizationOutPatientCareVisitsByIcdChartKeyIndex"
                        v-if="healthcareResourceUtilizationOutPatientCareVisitsByIcdChartData.length !== 0"/>
                <v-progress-circular color="primary" indeterminate v-else></v-progress-circular>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col class="ms-10">
                <v-checkbox v-model="healthcareResourceUtilizationOutPatientCareVisitsByIcdChartSelectedRelative"
                            label="Visits per patient in care"
                            hide-details></v-checkbox>
              </v-col>
              <v-col>
                <v-checkbox v-model="healthcareResourceUtilizationOutPatientCareVisitsByIcdChartSelectedPatientsAtRisk"
                            label="Show patients at risk"
                            hide-details></v-checkbox>
              </v-col>
              <v-col>
                <v-checkbox v-model="healthcareResourceUtilizationOutPatientCareVisitsByIcdChartSelectedPatientsInCare"
                            label="Show patients in care"
                            hide-details></v-checkbox>
              </v-col>
              <v-col class="me-10 text-right">
                <vue-to-print :content="() => this.$refs['healthcare-resource-utilization-out-patient-care-visits-by-icd-chart'].$el"
                              :document-title="icd + '-' + 'healthcare-resource-utilization-out-patient-care-visits-by-icd-chart'"
                              remove-after-print>
                  <template v-slot:trigger>
                    <v-btn variant="plain" icon="mdi-printer" class="end"></v-btn>
                  </template>
                </vue-to-print>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" lg="6" xl="6" xxl="6">
          <v-card class="mx-auto" min-height="800" elevation="0" title=""
                  ref="healthcare-resource-utilization-all-specialist-care-visits-by-icd-chart">
            <v-row no-gutters>
              <v-col>
                <GChart type="ColumnChart"
                        @ready="healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartReady"
                        :data="healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartData"
                        :options="healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartOptions"
                        :key="'healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChart' + healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartKeyIndex"
                        v-if="healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartData.length !== 0"/>
                <v-progress-circular color="primary" indeterminate v-else></v-progress-circular>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col class="ms-10">
                <v-checkbox v-model="healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartSelectedRelative"
                            label="Visits per patient in care"
                            hide-details></v-checkbox>
              </v-col>
              <v-col>
                <v-checkbox v-model="healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartSelectedPatientsAtRisk"
                            label="Show patients at risk"
                            hide-details></v-checkbox>
              </v-col>
              <v-col>
                <v-checkbox v-model="healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartSelectedPatientsInCare"
                            label="Show patients in care"
                            hide-details></v-checkbox>
              </v-col>
              <v-col class="me-10 text-right">
                <vue-to-print :content="() => this.$refs['healthcare-resource-utilization-all-specialist-care-visits-by-icd-chart'].$el"
                              :document-title="icd + '-' + 'healthcare-resource-utilization-all-specialist-care-visits-by-icd-chart'"
                              remove-after-print>
                  <template v-slot:trigger>
                    <v-btn variant="plain" icon="mdi-printer" class="end"></v-btn>
                  </template>
                </vue-to-print>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" lg="12" xl="12" xxl="12">
          <v-card class="mx-auto" elevation="0"
                  ref="icd-legend">
            <v-row no-gutters>
              <v-col>
                <v-data-table :headers="icdLegendHeaders"
                              :items="icdLegend"
                              density="compact"
                              :fixed-header="true"
                              :items-per-page="0"
                              class="no-row-borders allow-line-breaks striped-table">
                  <template #bottom></template>
                  <template v-slot:no-data>
                    <v-progress-circular color="primary" indeterminate></v-progress-circular>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col class="text-right">
                <vue-to-print :content="() => this.$refs['icd-legend'].$el"
                              :document-title="icd + '-' + 'icd-legend'"
                              remove-after-print>
                  <template v-slot:trigger>
                    <v-btn variant="plain" icon="mdi-printer" class="end"></v-btn>
                  </template>
                </vue-to-print>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-sheet>
</template>

<script>
import {defineComponent} from 'vue';
import {GChart} from 'vue-google-charts'
import axios from "axios";
import { VueToPrint } from "vue-to-print";

export default defineComponent({
  name: 'InternalOrderCancerTreatmentPatternInterventions',
  props: {
    icd: String,
    visible: Boolean
  },
  components: {
    GChart,
    VueToPrint
  },
  computed: {
    healthcareResourceUtilizationInPatientCareVisitsByIcdChartOptions() {
      return this.healthcareResourceUtilizationByIcdChartOptions('Inpatient care visits by disease classification (ICD-10 chapter)',
          this.healthcareResourceUtilizationInPatientCareVisitsByIcdChartSelectedRelative ? 'Number of visits per patient in care' : 'Number of visits',
          () => { return this.healthcareResourceUtilizationInPatientCareVisitsByIcdChartSelectedPatientsAtRisk },
          () => { return this.healthcareResourceUtilizationInPatientCareVisitsByIcdChartSelectedPatientsInCare });
    },
    healthcareResourceUtilizationInPatientCareDaysByIcdChartOptions() {
      return this.healthcareResourceUtilizationByIcdChartOptions('Number of days with inpatient care by disease classification (ICD-10 chapter)',
          this.healthcareResourceUtilizationInPatientCareDaysByIcdChartSelectedRelative ? 'Number of days per patient in care' : 'Number of days',
          () => { return this.healthcareResourceUtilizationInPatientCareDaysByIcdChartSelectedPatientsAtRisk },
          () => { return this.healthcareResourceUtilizationInPatientCareDaysByIcdChartSelectedPatientsInCare });
    },
    healthcareResourceUtilizationOutPatientCareVisitsByIcdChartOptions() {
      return this.healthcareResourceUtilizationByIcdChartOptions('Outpatient care visits by disease classification (ICD-10 chapter)',
          this.healthcareResourceUtilizationOutPatientCareVisitsByIcdChartSelectedRelative ? 'Number of visits per patient in care' : 'Number of visits',
          () => { return this.healthcareResourceUtilizationOutPatientCareVisitsByIcdChartSelectedPatientsAtRisk },
          () => { return this.healthcareResourceUtilizationOutPatientCareVisitsByIcdChartSelectedPatientsInCare });
    },
    healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartOptions() {
      return this.healthcareResourceUtilizationByIcdChartOptions('All specialist care visits by disease classification (ICD-10 chapter)',
          this.healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartSelectedRelative ? 'Number of visits per patient in care' : 'Number of visits',
          () => { return this.healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartSelectedPatientsAtRisk },
          () => { return this.healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartSelectedPatientsInCare });
    }
  },
  data: () => ({
    healthcareResourceUtilizationInPatientCareVisitsByIcdChartKeyIndex: 0,
    healthcareResourceUtilizationInPatientCareVisitsByIcdChartSelectedSeries: undefined,
    healthcareResourceUtilizationInPatientCareVisitsByIcdChartSelectedRelative: false,
    healthcareResourceUtilizationInPatientCareVisitsByIcdChartSelectedPatientsAtRisk: true,
    healthcareResourceUtilizationInPatientCareVisitsByIcdChartSelectedPatientsInCare: true,
    healthcareResourceUtilizationInPatientCareVisitsByIcdChartData: [],
    healthcareResourceUtilizationInPatientCareDaysByIcdChartKeyIndex: 0,
    healthcareResourceUtilizationInPatientCareDaysByIcdChartSelectedSeries: undefined,
    healthcareResourceUtilizationInPatientCareDaysByIcdChartSelectedRelative: false,
    healthcareResourceUtilizationInPatientCareDaysByIcdChartSelectedPatientsAtRisk: true,
    healthcareResourceUtilizationInPatientCareDaysByIcdChartSelectedPatientsInCare: true,
    healthcareResourceUtilizationInPatientCareDaysByIcdChartData: [],
    healthcareResourceUtilizationOutPatientCareVisitsByIcdChartKeyIndex: 0,
    healthcareResourceUtilizationOutPatientCareVisitsByIcdChartSelectedSeries: undefined,
    healthcareResourceUtilizationOutPatientCareVisitsByIcdChartSelectedRelative: false,
    healthcareResourceUtilizationOutPatientCareVisitsByIcdChartSelectedPatientsAtRisk: true,
    healthcareResourceUtilizationOutPatientCareVisitsByIcdChartSelectedPatientsInCare: true,
    healthcareResourceUtilizationOutPatientCareVisitsByIcdChartData: [],
    healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartKeyIndex: 0,
    healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartSelectedSeries: undefined,
    healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartSelectedRelative: false,
    healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartSelectedPatientsAtRisk: true,
    healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartSelectedPatientsInCare: true,
    healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartData: [],
    icdLegendHeaders: [
      {
        title: 'Legend',
        align: 'start',
        key: 'icd',
        sortable: false
      },
      {
        title: '',
        align: 'start',
        key: 'icd_description',
        sortable: false
      }
    ],
    icdLegend: []
  }),
  watch: {
    healthcareResourceUtilizationInPatientCareVisitsByIcdChartSelectedSeries() {
      this.loadHealthcareResourceUtilizationInPatientCareVisitsByIcdData(
          this.healthcareResourceUtilizationInPatientCareVisitsByIcdChartSelectedSeries,
          this.healthcareResourceUtilizationInPatientCareVisitsByIcdChartSelectedRelative).then((response) => {
        this.healthcareResourceUtilizationInPatientCareVisitsByIcdChartData = response.data
      })
    },
    healthcareResourceUtilizationInPatientCareVisitsByIcdChartSelectedRelative() {
      this.loadHealthcareResourceUtilizationInPatientCareVisitsByIcdData(
          this.healthcareResourceUtilizationInPatientCareVisitsByIcdChartSelectedSeries,
          this.healthcareResourceUtilizationInPatientCareVisitsByIcdChartSelectedRelative).then((response) => {
        this.healthcareResourceUtilizationInPatientCareVisitsByIcdChartData = response.data
      })
    },
    healthcareResourceUtilizationInPatientCareDaysByIcdChartSelectedSeries() {
      this.loadHealthcareResourceUtilizationInPatientCareDaysByIcdData(
          this.healthcareResourceUtilizationInPatientCareDaysByIcdChartSelectedSeries,
          this.healthcareResourceUtilizationInPatientCareDaysByIcdChartSelectedRelative).then((response) => {
        this.healthcareResourceUtilizationInPatientCareDaysByIcdChartData = response.data
      })
    },
    healthcareResourceUtilizationInPatientCareDaysByIcdChartSelectedRelative() {
      this.loadHealthcareResourceUtilizationInPatientCareDaysByIcdData(
          this.healthcareResourceUtilizationInPatientCareDaysByIcdChartSelectedSeries,
          this.healthcareResourceUtilizationInPatientCareDaysByIcdChartSelectedRelative).then((response) => {
        this.healthcareResourceUtilizationInPatientCareDaysByIcdChartData = response.data
      })
    },
    healthcareResourceUtilizationOutPatientCareVisitsByIcdChartSelectedSeries() {
      this.loadHealthcareResourceUtilizationOutPatientCareVisitsByIcdData(
          this.healthcareResourceUtilizationOutPatientCareVisitsByIcdChartSelectedSeries,
          this.healthcareResourceUtilizationOutPatientCareVisitsByIcdChartSelectedRelative).then((response) => {
        this.healthcareResourceUtilizationOutPatientCareVisitsByIcdChartData = response.data
      })
    },
    healthcareResourceUtilizationOutPatientCareVisitsByIcdChartSelectedRelative() {
      this.loadHealthcareResourceUtilizationOutPatientCareVisitsByIcdData(
          this.healthcareResourceUtilizationOutPatientCareVisitsByIcdChartSelectedSeries,
          this.healthcareResourceUtilizationOutPatientCareVisitsByIcdChartSelectedRelative).then((response) => {
        this.healthcareResourceUtilizationOutPatientCareVisitsByIcdChartData = response.data
      })
    },
    healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartSelectedSeries() {
      this.loadHealthcareResourceUtilizationAllSpecialistCareVisitsByIcdData(
          this.healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartSelectedSeries,
          this.healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartSelectedRelative).then((response) => {
        this.healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartData = response.data
      })
    },
    healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartSelectedRelative() {
      this.loadHealthcareResourceUtilizationAllSpecialistCareVisitsByIcdData(
          this.healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartSelectedSeries,
          this.healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartSelectedRelative).then((response) => {
        this.healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartData = response.data
      })
    }
  },
  methods: {
    forceRerender() {
      this.healthcareResourceUtilizationInPatientCareVisitsByIcdChartKeyIndex += 1;
      this.healthcareResourceUtilizationInPatientCareDaysByIcdChartKeyIndex += 1;
      this.healthcareResourceUtilizationOutPatientCareVisitsByIcdChartKeyIndex += 1;
      this.healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartKeyIndex += 1;
    },
    healthcareResourceUtilizationByIcdChartOptions(title, vAxis0Title, getSelectedPatientsAtRisk,
                                                   getSelectedPatientsInCare) {
      const series = {
        0: {
          targetAxisIndex: 1,
          type: 'line',
          pointShape: 'diamond',
          pointSize: 10
        },
        1: {
          targetAxisIndex: 1,
          type: 'line',
          pointShape: 'diamond',
          pointSize: 10
        },
        2: {
          targetAxisIndex: 0
        }
      }
      if (!getSelectedPatientsAtRisk()) {
        series[0] = {
          targetAxisIndex: 1,
          color: 'transparent',
          enableInteractivity: false,
          visibleInLegend: false
        }
      }
      if (!getSelectedPatientsInCare()) {
        series[1] = {
          targetAxisIndex: 1,
          color: 'transparent',
          enableInteractivity: false,
          visibleInLegend: false
        }
      }
      return {
        backgroundColor: {
          fill: '#364c5b'
        },
        title: title,
        titlePosition: 'out',
        titleTextStyle: {
          color: '#ffffff',
          bold: false
        },
        height: 800,
        colors: ['#fb9a99', '#a6cee3', '#b2df8a', '#fdbf6f', '#cab2d6', '#ffff99', '#1f78b4', '#33a02c', '#bdbdc7'],
        legend: {
          position: 'top',
          alignment: 'end',
          maxLines: 5,
          textStyle: {
            color: '#c0c0c0',
            fontSize: 12
          },
          scrollArrows: {
            activeColor: '#f0f0f0',
            inactiveColor: 'c0c0c0'
          },
          pagingTextStyle: {
            color: '#f0f0f0'
          }
        },
        isStacked: true,
        series: {
          ...series
        },
        hAxis: {
          title: 'Follow-up year',
          titleTextStyle: {
            color: '#f0f0f0',
            italic: false
          },
          gridlines: {
            count: 0
          },
          minorGridlines: {
            count: 0
          },
          textStyle: {
            color: '#ffffff',
            fontSize: 12
          },
          minTextSpacing: 1
        },
        vAxes: {
          0: {
            title: vAxis0Title,
            titleTextStyle: {
              color: '#f0f0f0',
              italic: false
            },
            gridlines: {
              count: 0
            },
            minorGridlines: {
              count: 0
            },
            textStyle: {
              color: '#ffffff',
              fontSize: 12
            }
          },
          1: {
            title: 'Number of patients',
            titleTextStyle: {
              color: '#f0f0f0',
              italic: false
            },
            gridlines: {
              color: '#364c5b',
              count: 0
            },
            minorGridlines: {
              color: '#364c5b',
              count: 0
            },
            textStyle: {
              color: '#ffffff',
              fontSize: 12
            }
          }
        },
        intervals: {
          'style': 'boxes',
          'boxWidth': 1,
          'lineWidth': 0,
          'fillOpacity': 0.2
        },
        tooltip: {
          isHtml: true
        },
        annotations: {
          textStyle: {
            fontSize: 12,
            color: '#808080',
            auraColor: 'none'
          }
        },
        animation: {
          startup: true,
          duration: 500,
          easing: 'out'
        }
      }
    },
    async loadHealthcareResourceUtilizationInPatientCareVisitsByIcdData(diagnosisGroup, relative) {
      return axios.get('cancer-internal-order/healthcare-in-patient-care-visits-by-icd-resource-utilization',
          {
            headers: {Authorization: `Bearer ${this.$store.getters.stateUser.keycloak_token}`},
            params: {
              icd: this.icd,
              diagnosis_group: diagnosisGroup,
              relative: relative
            }
          });
    },
    async loadHealthcareResourceUtilizationInPatientCareDaysByIcdData(diagnosisGroup, relative) {
      return axios.get('cancer-internal-order/healthcare-in-patient-care-days-by-icd-resource-utilization',
          {
            headers: {Authorization: `Bearer ${this.$store.getters.stateUser.keycloak_token}`},
            params: {
              icd: this.icd,
              diagnosis_group: diagnosisGroup,
              relative: relative
            }
          });
    },
    async loadHealthcareResourceUtilizationOutPatientCareVisitsByIcdData(diagnosisGroup, relative) {
      return axios.get('cancer-internal-order/healthcare-out-patient-care-visits-by-icd-resource-utilization',
          {
            headers: {Authorization: `Bearer ${this.$store.getters.stateUser.keycloak_token}`},
            params: {
              icd: this.icd,
              diagnosis_group: diagnosisGroup,
              relative: relative
            }
          });
    },
    async loadHealthcareResourceUtilizationAllSpecialistCareVisitsByIcdData(diagnosisGroup, relative) {
      return axios.get('cancer-internal-order/healthcare-all-specialist-care-visits-by-icd-resource-utilization',
          {
            headers: {Authorization: `Bearer ${this.$store.getters.stateUser.keycloak_token}`},
            params: {
              icd: this.icd,
              diagnosis_group: diagnosisGroup,
              relative: relative
            }
          });
    },
    async loadIcdLegend() {
      return axios.get('cancer-internal-order/icd-legend', {
        headers: {Authorization: `Bearer ${this.$store.getters.stateUser.keycloak_token}`},
        params: {
          icd: this.icd
        }
      });
    },
    async healthcareResourceUtilizationInPatientCareVisitsByIcdChartReady(chart, google) {
      await this.healthcareResourceUtilizationChartReady(chart, google,
          this.healthcareResourceUtilizationInPatientCareVisitsByIcdChartData,
          () => {
            return this.healthcareResourceUtilizationInPatientCareVisitsByIcdChartSelectedSeries
          },
          (s) => {
            this.healthcareResourceUtilizationInPatientCareVisitsByIcdChartSelectedSeries = s
          })
    },
    async healthcareResourceUtilizationInPatientCareDaysByIcdChartReady(chart, google) {
      await this.healthcareResourceUtilizationChartReady(chart, google,
          this.healthcareResourceUtilizationInPatientCareDaysByIcdChartData,
          () => {
            return this.healthcareResourceUtilizationInPatientCareDaysByIcdChartSelectedSeries
          },
          (s) => {
            this.healthcareResourceUtilizationInPatientCareDaysByIcdChartSelectedSeries = s
          })
    },
    async healthcareResourceUtilizationOutPatientCareVisitsByIcdChartReady(chart, google) {
      await this.healthcareResourceUtilizationChartReady(chart, google,
          this.healthcareResourceUtilizationOutPatientCareVisitsByIcdChartData,
          () => {
            return this.healthcareResourceUtilizationOutPatientCareVisitsByIcdChartSelectedSeries
          },
          (s) => {
            this.healthcareResourceUtilizationOutPatientCareVisitsByIcdChartSelectedSeries = s
          })
    },
    async healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartReady(chart, google) {
      await this.healthcareResourceUtilizationChartReady(chart, google,
          this.healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartData,
          () => {
            return this.healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartSelectedSeries
          },
          (s) => {
            this.healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartSelectedSeries = s
          })
    },
    async healthcareResourceUtilizationChartReady(chart, google, chartData, getSelectedSeries, setSelectedSeries) {
      const setSeriesChartSelection = (selectedColumn) => {
        let selectedSeries = chartData[0][selectedColumn]
        if (getSelectedSeries() === selectedSeries) {
          setSelectedSeries(undefined)
        } else {
          setSelectedSeries(selectedSeries)
        }
      }

      const resetSeriesChartSelection = () => {
        setSelectedSeries(undefined)
      }

      const seriesSelectHandler = function () {
        const selection = chart.getSelection()
        if (selection.length === 0) {
          resetSeriesChartSelection()
          return
        }
        const selectedItem = selection[0];
        if (selectedItem.column >= 11) {
          setSeriesChartSelection(selectedItem.column)
        }
      }

      google.visualization.events.addListener(chart, 'select', seriesSelectHandler);
    }
  },
  async mounted() {
    await Promise.all([
      this.loadHealthcareResourceUtilizationInPatientCareVisitsByIcdData(),
      this.loadHealthcareResourceUtilizationInPatientCareDaysByIcdData(),
      this.loadHealthcareResourceUtilizationOutPatientCareVisitsByIcdData(),
      this.loadHealthcareResourceUtilizationAllSpecialistCareVisitsByIcdData(),
      this.loadIcdLegend()
    ]).then(responses => {
      this.healthcareResourceUtilizationInPatientCareVisitsByIcdChartData = responses[0].data;
      this.healthcareResourceUtilizationInPatientCareDaysByIcdChartData = responses[1].data;
      this.healthcareResourceUtilizationOutPatientCareVisitsByIcdChartData = responses[2].data;
      this.healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartData = responses[3].data;
      this.icdLegend = responses[4].data
    })
  },
  updated() {
    if (this.visible) {
      this.forceRerender()
    }
  }
});
</script>

<style scoped>
.no-row-borders :deep(.v-data-table__tr) {
  border-bottom: none !important;
  box-shadow: none !important;
}

.no-row-borders :deep(.v-data-table__td) {
  border-bottom: none !important;
  box-shadow: none !important;
}

.no-row-borders :deep(.v-data-table__th) {
  border-bottom: none !important;
}

.allow-line-breaks :deep(.v-data-table__td) {
  white-space: pre-line;
}

.striped-table :deep(tbody tr:nth-child(odd)) {
  background-color: rgba(0, 0, 0, .10);
}

@media print {
  .mx-auto {
    zoom: 50%;
  }
}
</style>
